import React from 'react'
import { Form } from '@joehua/cms-components'

const fields = [
  {
    field: 'name',
    label: 'Tên*',
    helpText: 'Tên của bạn',
    validateType: 'string',
    validators: [
      {
        name: 'required',
        params: ['Vui lòng điền tên'],
      },
    ],
  },
  {
    field: 'phone',
    label: 'Điện thoại*',
    helpText: 'Điện thoại',
    validateType: 'string',
    validators: [
      {
        name: 'required',
        params: ['Vui lòng điền điện thoại'],
      },
      {
        name: 'matches',
        params: ['(0[0-9]{9})\\b', 'Điện thoại không hợp lệ'],
      },
    ],
  },
  {
    field: 'email',
    label: 'Email',
    helpText: 'Email',
    validateType: 'string',
    validators: [],
  },
]
export default function RealProjectOrder() {
  return (
    <div className="mw6 center">
      <div className="tc">
        <h3 className="ttu rf f4 dark-red">Đăng ký nhận đánh giá dự án chi tiết</h3>
        <h4>Đánh giá trung thực – Bảo vệ tài chính</h4>
      </div>
      <div>
        <Form
          form={
            {
              fields,
              defaultValues: {},
              code: 'conghoagarden.com.vn_order',
              submitText: 'Tải ngay phân tích chi tiết',
            } as any
          }
          subscribeEndpoint="https://cms-1-api.enveloped.org/subscribe"
          theme={{
            root: '',
            submitButton: 'ph3 pv2 bn ttu f6 white mt3 bg-dark-red',
            formItem: {
              helpTextWrapper: 'dn',
            },
          }}
        />
      </div>
    </div>
  )
}
